(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["bls-notify"] && !Shopify.designMode) return;
  try {
    (function () {
  if (window.__blsNotify) return;
  window.__blsNotify = true;
  var KEY = 'blsNotify';
  function modal() { return document.querySelector('[data-bls-notify]'); }
  function store(v) { try { if (v) sessionStorage.setItem(KEY, v); else sessionStorage.removeItem(KEY); } catch (e) {} }
  function read() { try { return sessionStorage.getItem(KEY); } catch (e) { return null; } }
  function open(name) {
    var m = modal();
    if (!m) return;
    if (name) {
      var n = m.querySelector('[data-bls-notify-name]');
      if (n) n.textContent = name;
      var t = m.querySelector('[data-bls-notify-tags]');
      if (t) t.value = 'me-prevenir, ' + name;
    }
    m.hidden = false;
    document.documentElement.classList.add('bls-lock');
    var f = m.querySelector('input[type="email"]');
    if (f) setTimeout(function () { f.focus(); }, 30);
  }
  function close() {
    var m = modal();
    if (!m) return;
    m.hidden = true;
    document.documentElement.classList.remove('bls-lock');
  }
  document.addEventListener('click', function (e) {
    var o = e.target.closest('[data-bls-notify-open]');
    if (o) { e.preventDefault(); open(o.getAttribute('data-product') || ''); return; }
    if (e.target.closest('[data-bls-notify-close]')) close();
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });
  /* Mémorise quel formulaire a été envoyé (fenêtre ou formulaire en ligne) pour le rouvrir / y revenir après le rechargement */
  document.addEventListener('submit', function (e) {
    var f = e.target;
    if (f.closest && f.closest('[data-bls-notify]')) store('modal');
    else if (f.id && f.id.indexOf('BlsNotifyInline') === 0) store('inline:' + f.id);
  }, true);
  function init() {
    var v = read();
    if (!v) return;
    store(null);
    if (v === 'modal') {
      var m = modal();
      if (m && m.querySelector('[data-bls-notify-done]')) open('');
    } else if (v.indexOf('inline:') === 0) {
      var el = document.getElementById(v.slice(7));
      if (el) el.scrollIntoView({ block: 'center' });
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
  } catch(e) { console.error(e); }
})();

})();
